const content = [
    {
        'topic': 'DELIVERY',
        'questions': [
            {
                'question': 'Wie hoch sind die Versandkosten bei OTTO?',
                'trackingLabel': 'delivery-shipping-costs-otto',
                'answerUrl': '/shoppages/shippingcosts-faq'
            },
            {
                'question': 'Gratis Versand mit OTTO UP?',
                'trackingLabel': 'delivery-free-shipping-otto-up',
                'answerUrl': '/shoppages/shipping-costs-ottoup-faq'
            },
            {
                'question': 'Welche Versandarten, Lieferservices und Lieferzeiten gibt es?',
                'trackingLabel': 'delivery-shipping-services-otto',
                'answerUrl': '/shoppages/shipping-services-faq'
            }
        ],
        'type': 'general'
    },
    {
        'topic': 'PAYMENT',
        'questions': [
            {
                'question': 'Welche Zahlungsarten habe ich zur Auswahl?',
                'trackingLabel': 'payment-methods-otto',
                'answerUrl': '/shoppages/payment-methods-faq'
            },
            {
                'question': 'Kann ich nachträglich meine gewählte Zahlungsart wechseln?',
                'trackingLabel': 'payment-change-payment-method',
                'answerUrl': '/shoppages/change-payment-method-faq'
            },
            {
                'question': 'Wer ist OTTO Payments?',
                'trackingLabel': 'payment-otto-payments-who',
                'answerUrl': '/shoppages/otto-payments-who-faq'
            }
        ],
        'type': 'general'
    },
    {
        'topic': 'RETURNS',
        'questions': [
            {
                'question': 'Wie sind die Rücksendebedingungen?',
                'trackingLabel': 'returns-conditions',
                'answerUrl': '/shoppages/return-guidelines-faq'
            },
            {
                'question': 'Werden Versandkosten oder Serviceaufschläge bei einer Rücksendung erstattet?',
                'trackingLabel': 'returns-refund-shipping-costs',
                'answerUrl': '/shoppages/return-refund-service-costs-faq'
            },
            {
                'question': 'Werden UP Punkte oder eingelöste Gutscheine bei einer Rücksendung erstattet?',
                'trackingLabel': 'returns-refund-otto-up-points-or-vouchers',
                'answerUrl': '/shoppages/return-refund-points-vouchers-faq'
            }
        ],
        'type': 'general'
    },
    {
        'topic': 'ACCOUNT',
        'questions': [
            {
                'question': 'Was kann ich tun, wenn mein Kundenkonto gesperrt ist?',
                'trackingLabel': 'account-blocked',
                'answerUrl': '/shoppages/account-blocked-faq'
            },
            {
                'question': 'Was mache ich, wenn ich meine E-Mail-Adresse vergessen habe?',
                'trackingLabel': 'account-forgotten-email',
                'answerUrl': '/shoppages/email-forgotten-faq'
            },
            {
                'question': 'Wo finde ich meine Kundennummer und wofür brauche ich diese?',
                'trackingLabel': 'account-customer-id',
                'answerUrl': '/shoppages/customerid-not-found-faq'
            },
            {
                'question': 'Wie kann ich meine persönlichen Daten (z.B. Name, Anschrift, E-Mail-Adresse) ändern?',
                'trackingLabel': 'account-change-personal-data',
                'answerUrl': '/shoppages/change-personal-data-faq'
            },
            {
                'question': 'Wie lege ich ein Kundenkonto an?',
                'trackingLabel': 'account-create-account',
                'answerUrl': '/shoppages/new-account-registration-faq'
            },
            {
                'question': 'Kann ich als Gast ohne Kundenkonto bestellen?',
                'trackingLabel': 'account-order-as-guest',
                'answerUrl': '/shoppages/guest-order-faq'
            }
        ],
        'type': 'general'
    }
]

export default content
